/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { CSSProperties } from "styled-components";

export const timerStyle: CSSProperties = {
	fontSize: "clamp(1px, 1.8dvw, 20px)",
	whiteSpace: "nowrap",
	padding: "0.3em 0.6em",
	backgroundColor: "#fff",
	top: "10%",
	left: "50%",
	transform: "translate(-50%, -50%)"
};

export const timerStyleMobile: CSSProperties = {
	...timerStyle,
	fontSize: "clamp(1px, 2.8dvw, 24px)",
	top: "5%"
};
